import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Paper,
  alpha,
} from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import FlashOnIcon from '@mui/icons-material/FlashOn';

interface OrderTypeModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (isDirect: boolean) => void;
}

const OrderTypeModal: React.FC<OrderTypeModalProps> = ({ open, onClose, onSelect }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="order-type-selection"
      disableAutoFocus
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(4px)',
      }}
    >
      <Box
        sx={{
          width: { xs: '90%', sm: 450 },
          outline: 'none',
        }}
      >
        <Paper
          elevation={24}
          sx={{
            p: 4,
            borderRadius: 4,
            bgcolor: 'background.paper',
            textAlign: 'center',
          }}
        >
          <Typography variant="h5" fontWeight={700} gutterBottom>
            Select Order Type
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={4}>
            Please choose how you would like your order to be delivered.
          </Typography>

          <Box
            display="flex"
            flexDirection="column"
            gap={2}
          >
            {/* Normal Delivery Option */}
            <Box
              onClick={() => onSelect(false)}
              sx={{
                p: 3,
                cursor: 'pointer',
                borderRadius: 3,
                border: '2px solid #f0f0f0',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                '&:hover': {
                  borderColor: 'primary.main',
                  bgcolor: alpha('#1976d2', 0.05),
                  transform: 'translateY(-2px)',
                },
              }}
            >
              <Box
                sx={{
                  bgcolor: alpha('#1976d2', 0.1),
                  p: 1.5,
                  borderRadius: 2,
                  color: 'primary.main',
                }}
              >
                <LocalShippingIcon fontSize="large" />
              </Box>
              <Box textAlign="left">
                <Typography variant="h6" fontWeight={600}>
                  NORMAL DELIVERY
                </Typography>
              </Box>
            </Box>

            {/* Direct Delivery Option */}
            <Box
              onClick={() => onSelect(true)}
              sx={{
                p: 3,
                cursor: 'pointer',
                borderRadius: 3,
                border: '2px solid #f0f0f0',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                '&:hover': {
                  borderColor: 'warning.main',
                  bgcolor: alpha('#ed6c02', 0.05),
                  transform: 'translateY(-2px)',
                },
              }}
            >
              <Box
                sx={{
                  bgcolor: alpha('#ed6c02', 0.1),
                  p: 1.5,
                  borderRadius: 2,
                  color: 'warning.main',
                }}
              >
                <FlashOnIcon fontSize="large" />
              </Box>
              <Box textAlign="left">
                <Typography variant="h6" fontWeight={600}>
                  DIRECT DELIVERY
                </Typography>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Modal>
  );
};

export default OrderTypeModal;
